import React, { useRef, useState, useEffect } from 'react'
import { Modal, Box, Button, Typography, Grid } from '@material-ui/core'
import TermsAndConditionsApiUrls from 'src/apiUrls/TermsAndConditionsApiUrls'
import { components, useServices } from 'cng-web-lib';
import AlertDialog from 'src/components/aciacehighway/AlertDialog'

const {
  button: { CngButton },
  CngDialog
} = components

const mainBoxStyle = {
    position: "absolute",
    top: "30%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: 500,
    bgcolor: "background.paper",
    border: "2px solid black",
    boxShadow: 24,
    p: 4,
};

const contentBoxStyle = {
    marginTop: 20,
    marginLeft: "auto",
    marginRight: "auto",
    height: 300, 
    maxWidth: "90%", 
    overflow: "auto"
}

const acceptButtonBoxStyle = {
    marginTop: 20,
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    justifyContent: "center"
}

const enabledAcceptButtonStyle = {
    backgroundColor: "green",
    color: "white"
}

const disabledAcceptButtonStyle = {
    backgroundColor: "gray",
    color: "white"
}

function TermsAndConditions() {
    const boxRef = useRef(null);
    const { securedSendRequest } = useServices();
    const [openDialog, setOpenDialog] = useState(false)
    const [alertDialog, setAlertDialog] = useState(false)
    const [acceptButtonDisabled, setAcceptButtonDisabled] = useState(true)
    const [acceptButtonStyle, setAcceptButtonStyle] = useState(disabledAcceptButtonStyle)
    const [termsAndConditionsContent, setTermsAndConditionsContent] = useState("")
    const [termsAndConditionsVersionNumber, setTermsAndConditionsVersionNumber] = useState("")

    const handleScroll = (e) => {
		const { scrollTop, scrollHeight, clientHeight } = e.target;
		const position = Math.ceil((scrollTop / (scrollHeight - clientHeight)) * 100)
		
        if (position > 90) {
            setAcceptButtonDisabled(false)
            setAcceptButtonStyle(enabledAcceptButtonStyle)
        }
	};

    function handleAccept() {
        console.log("handleAccept")
        const formData = new FormData()
        formData.append('versionNumber', termsAndConditionsVersionNumber)

        function onSuccess(response) {
            let data = response.data
            let errorMessages = data.errorMessages
            if (response.status == 200) {
                if (errorMessages == null) {
                    setOpenDialog(false)
                } else {
                    setAlertDialog(true)
                }
            }
        }

        function onError(error) {
            console.log("Failed to retrieve Terms And Conditions", error)
        }

        function onComplete() { }
        const config = {}

        securedSendRequest.execute('POST', TermsAndConditionsApiUrls.ACCEPT_TERMS_AND_CONDITIONS, formData, onSuccess, onError, onComplete, config, null);
    }

    useEffect(() => {
        function onSuccess(response) {
            let data = response.data
            let errorMessages = data.errorMessages
            if (response.status == 200 && data != null && errorMessages == null) {
                if (data.content != null && data.content != '') {
                    setTermsAndConditionsContent(data.content)
                    setTermsAndConditionsVersionNumber(data.versionNumber)
                    setOpenDialog(true)
                    
                    if (boxRef.current) {
                        if (boxRef.current.firstChild.clientHeight < 300) {
                            setAcceptButtonDisabled(false)
                            setAcceptButtonStyle(enabledAcceptButtonStyle)
                        } else {
                            setAcceptButtonDisabled(true)
                        }
                    }
                }
            }
        }

        function onError(error) {
            console.log("Failed to retrieve Terms And Conditions", error)
        }

        function onComplete() { }
        const config = {}
        const formData = {}

        securedSendRequest.execute('POST', TermsAndConditionsApiUrls.GET_TERMS_AND_CONDITIONS, formData, onSuccess, onError, onComplete, config, null);
    }, []);

    return (
        <>
            <Modal
                open={openDialog}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                disableEscapeKeyDown={true}
                hideBackdrop={true}
            >
                <Box sx={mainBoxStyle}>
                    <Typography variant="h2" align="center">
                        Terms and Conditions
                    </Typography>
                    <Typography variant="h5" align="center">
                        Please read all and accept to continue
                    </Typography>                    
                    <Box style={contentBoxStyle} onScroll={handleScroll} ref={boxRef}>
                        <Typography>
                            <div
                                dangerouslySetInnerHTML={{ __html: termsAndConditionsContent }}
                            />
                        </Typography>                      
                    </Box>
                    <Box style={acceptButtonBoxStyle}>
                        <Button
                            variant="contained"
                            onClick={handleAccept}
                            disabled={acceptButtonDisabled}
                            style={acceptButtonStyle}
                        >
                            ACCEPT AND CONTINUE
                        </Button>  
                    </Box>                    
                </Box>
            </Modal>
            <CngDialog
            dialogContent='Something went wrong, please refresh and try again.'
            dialogTitle='Alert'
            fullWidth
            maxWidth='sm'
            open={alertDialog}
            dialogAction={
                <>
                <CngButton
                    color='primary'
                    onClick={() => window.location.reload()}
                >
                    OK
                </CngButton>
                </>
            }
            shouldShowCloseButton
            />
      </>     
    );

}

export default TermsAndConditions